// extracted by mini-css-extract-plugin
export default {"violetColor":"#9300da"};